/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca, Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import addAchievementsTab from './addAchievementsTab';
import addAssignControl from './addAssignControl';
import notifications from './notifications';

export default () => {
	// Add a new tab to the user profile page
	addAchievementsTab();
	notifications();
	addAssignControl();
};
